import http from "../http-common";

/**
 * Loyalty program API (/api/loyalty/*). Locations reuse location.service.js.
 */
class LoyaltyDataService {
  // Dashboard & settings
  getDashboard() {
    return http.get('/loyalty/dashboard');
  }

  getSettings() {
    return http.get('/loyalty/settings');
  }

  updateSettings(data) {
    return http.put('/loyalty/settings', data);
  }

  // Clients (global identity + this tenant's membership)
  getClients(params = {}) {
    return http.get('/loyalty/clients', { params });
  }

  lookupClient(q) {
    return http.get('/loyalty/clients/lookup', { params: { q } });
  }

  enrollClient(data) {
    return http.post('/loyalty/clients', data);
  }

  getClient(uuid) {
    return http.get(`/loyalty/clients/${uuid}`);
  }

  updateClient(uuid, data) {
    return http.put(`/loyalty/clients/${uuid}`, data);
  }

  getClientLoyalty(uuid) {
    return http.get(`/loyalty/clients/${uuid}/loyalty`);
  }

  getClientTransactions(uuid, params = {}) {
    return http.get(`/loyalty/clients/${uuid}/transactions`, { params });
  }

  getClientLedger(uuid, params = {}) {
    return http.get(`/loyalty/clients/${uuid}/ledger`, { params });
  }

  getClientRedemptions(uuid, params = {}) {
    return http.get(`/loyalty/clients/${uuid}/redemptions`, { params });
  }

  registerPurchase(uuid, data) {
    return http.post(`/loyalty/clients/${uuid}/purchase`, data);
  }

  adjustPoints(uuid, data) {
    return http.post(`/loyalty/clients/${uuid}/adjust`, data);
  }

  // Transactions
  getTransactions(params = {}) {
    return http.get('/loyalty/transactions', { params });
  }

  getTransaction(uuid) {
    return http.get(`/loyalty/transactions/${uuid}`);
  }

  refundTransaction(uuid, data = {}) {
    return http.post(`/loyalty/transactions/${uuid}/refund`, data);
  }

  // Rewards
  getRewards(params = {}) {
    return http.get('/loyalty/rewards', { params });
  }

  createReward(data) {
    return http.post('/loyalty/rewards', data);
  }

  updateReward(uuid, data) {
    return http.put(`/loyalty/rewards/${uuid}`, data);
  }

  deleteReward(uuid) {
    return http.delete(`/loyalty/rewards/${uuid}`);
  }

  uploadRewardImage(uuid, file) {
    const formData = new FormData();
    formData.append('image', file);
    return http.post(`/loyalty/rewards/${uuid}/image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  removeRewardImage(uuid) {
    return http.delete(`/loyalty/rewards/${uuid}/image`);
  }

  redeemReward(uuid, data) {
    return http.post(`/loyalty/rewards/${uuid}/redeem`, data);
  }

  // Promotions (announcements / promos in the customer app)
  getPromotions() {
    return http.get('/loyalty/promotions');
  }

  createPromotion(data) {
    return http.post('/loyalty/promotions', data);
  }

  updatePromotion(uuid, data) {
    return http.put(`/loyalty/promotions/${uuid}`, data);
  }

  deletePromotion(uuid) {
    return http.delete(`/loyalty/promotions/${uuid}`);
  }

  uploadPromotionImage(uuid, file) {
    const formData = new FormData();
    formData.append('image', file);
    return http.post(`/loyalty/promotions/${uuid}/image`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  removePromotionImage(uuid) {
    return http.delete(`/loyalty/promotions/${uuid}/image`);
  }

  getRedemptions(params = {}) {
    return http.get('/loyalty/redemptions', { params });
  }
}

export default new LoyaltyDataService();
